import { css } from '@emotion/react'
import React from 'react'

type EndPaginationButtonProps = {
  current: number
  disabled: boolean
  onClick: (page: number) => any
}

type BasePaginationButtonProps = EndPaginationButtonProps & {
  left: boolean
}

const noop = () => {}
function BasePaginationButton({
  current,
  left,
  disabled,
  onClick,
}: BasePaginationButtonProps) {
  const props = {
    className: left ? 'pl-pagination-previous' : 'pl-pagination-next',
    onClick: noop,
  }
  const icon = left ? 'icomoon icon-arrow1-left' : 'icomoon icon-arrow1-right'
  if (disabled) {
    props.className += ' is-disabled'
  } else {
    const diff = left ? -1 : 1
    props.onClick = () => onClick(current + diff)
  }
  return (
    <li {...props} css={css(`cursor: pointer;`)}>
      <i className={icon} />
    </li>
  )
}

export const LeftPaginationButton = (props: EndPaginationButtonProps) => (
  <BasePaginationButton left {...props} />
)
export const RightPaginationButton = (props: EndPaginationButtonProps) => (
  <BasePaginationButton left={false} {...props} />
)
